export const modBossLogLevels = [
  'Trace',
  'Debug',
  'Info',
  'Warn',
  'Error',
  'Silent',
];
